<template>
  <div class="menuFrame">
    <loading :active.sync="isLoading"></loading>

    <div class="lightbox">
      <div>
        <div id="SliderTop">
          <i class="fas fa-2x fa-chevron-up toTop-arrow"></i>
        </div>

        <h1>VIP登錄名單</h1>
        <p class="my-3">&nbsp;</p>

        <div class="PcDevice">
          <table class="table">
            <thead class="thead-dark text-center">
              <tr>
                <th scope="col">No.</th>
                <th scope="col">姓名</th>
                <th scope="col">公司 / 職稱</th>
                <th scope="col">邀請時間</th>
                <th scope="col">刪除</th>
              </tr>
            </thead>
            <tbody class="text-center">
              <tr v-for="(item, key) in vipList" :key="item.No">
                <th scope="row" class="text-center">{{ item.No }}</th>
                <td>{{ item.VipName }}</td>
                <td>{{ item.VipCompany }}</td>
                <td>{{ item.CreateTime }}</td>
                <td>
                  <div
                    class="btn btn-secondary"
                    @click.prevent="DeleteVip(item.VipNo)"
                  >
                    刪除
                  </div>
                </td>
              </tr>
            </tbody>
          </table>

          <div v-if="totalPage > 1" class="pt-3 d-flex justify-content-center">
            <nav>
              <ul class="pagination">
                <li
                  v-if="totaltenPageNum > 1"
                  class="page-item"
                  :class="{ disabled: tenPageNum == 0 }"
                >
                  <a
                    class="page-link"
                    href="#"
                    title="切換前十頁"
                    aria-label="Previous"
                    @click="returntenPage()"
                  >
                    <span aria-hidden="true"
                      ><i class="fas fa-angle-double-left"></i
                    ></span>
                  </a>
                </li>
                <li class="page-item" :class="{ disabled: currentPage == 1 }">
                  <a
                    class="page-link"
                    href="#"
                    title="上一頁"
                    aria-label="Previous"
                    @click="lastPage()"
                  >
                    <span aria-hidden="true">
                      <i class="fas fa-angle-left"></i>
                    </span>
                  </a>
                </li>
                <li
                  class="page-item"
                  v-for="page in showpage"
                  :key="page"
                  :class="{ active: currentPage == page }"
                >
                  <a class="page-link" href="#" @click="getPage(page)">{{
                    page
                  }}</a>
                </li>

                <li
                  class="page-item"
                  :class="{ disabled: currentPage == totalPage }"
                >
                  <a
                    class="page-link"
                    href="#"
                    title="下一頁"
                    aria-label="Next"
                    @click="nextPage()"
                  >
                    <span aria-hidden="true"
                      ><i class="fas fa-angle-right"></i
                    ></span>
                  </a>
                </li>
                <li
                  v-if="totaltenPageNum > 1"
                  class="page-item"
                  :class="{ disabled: tenPageNum == totaltenPageNum - 1 }"
                >
                  <a
                    class="page-link"
                    href="#"
                    title="切換下十頁"
                    aria-label="Next"
                    @click="nexttenPage()"
                  >
                    <span aria-hidden="true"
                      ><i class="fas fa-angle-double-right"></i
                    ></span>
                  </a>
                </li>
              </ul>
              <p class="text-center mt-2">
                第 {{ currentPage }} / {{ totalPage }} 頁
              </p>
            </nav>
          </div>
        </div>

        <div class="MbDevice">
          <div class="row">
            <div
              class="col-sm-3 mb-2"
              v-for="(item, index) in vipList"
              :key="index"
            >
              <div class="card mt-3">
                <div class="card-body">
                  <div class="card-header" style="font-weight: bold">
                    No. {{ item.No }}
                  </div>
                  <ul class="list-group list-group-flush">
                    <li class="list-group-item">
                      <div>
                        <span class="font-weight-bold">姓名 :</span>
                        {{ item.VipName }}
                      </div>
                    </li>
                    <li class="list-group-item">
                      <div>
                        <span class="font-weight-bold">公司 / 職稱 :</span>
                        {{ item.VipCompany }}
                      </div>
                    </li>
                    <li class="list-group-item">
                      <span class="font-weight-bold">邀請時間 : </span
                      >{{ item.CreateTime }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div v-if="totalPage > 1" class="pt-3 d-flex justify-content-center">
            <nav>
              <ul class="pagination pagination-sm">
                <li
                  v-if="totaltenPageNum > 1"
                  class="page-item"
                  :class="{ disabled: tenPageNum == 0 }"
                >
                  <a
                    class="page-link"
                    href="#"
                    title="切換前十頁"
                    aria-label="Previous"
                    @click="returntenPage()"
                  >
                    <span aria-hidden="true"
                      ><i class="fas fa-angle-double-left"></i
                    ></span>
                  </a>
                </li>
                <li class="page-item" :class="{ disabled: currentPage == 1 }">
                  <a
                    class="page-link"
                    href="#"
                    title="上一頁"
                    aria-label="Previous"
                    @click="lastPage()"
                  >
                    <span aria-hidden="true">
                      <i class="fas fa-angle-left"></i>
                    </span>
                  </a>
                </li>
                <li
                  class="page-item"
                  v-for="page in showpage"
                  :key="page"
                  :class="{ active: currentPage == page }"
                >
                  <a class="page-link" href="#" @click="getPage(page)">{{
                    page
                  }}</a>
                </li>

                <li
                  class="page-item"
                  :class="{ disabled: currentPage == totalPage }"
                >
                  <a
                    class="page-link"
                    href="#"
                    title="下一頁"
                    aria-label="Next"
                    @click="nextPage()"
                  >
                    <span aria-hidden="true"
                      ><i class="fas fa-angle-right"></i
                    ></span>
                  </a>
                </li>
                <li
                  v-if="totaltenPageNum > 1"
                  class="page-item"
                  :class="{ disabled: tenPageNum == totaltenPageNum - 1 }"
                >
                  <a
                    class="page-link"
                    href="#"
                    title="切換下十頁"
                    aria-label="Next"
                    @click="nexttenPage()"
                  >
                    <span aria-hidden="true"
                      ><i class="fas fa-angle-double-right"></i
                    ></span>
                  </a>
                </li>
              </ul>
              <p class="text-center mt-2">
                第 {{ currentPage }} / {{ totalPage }} 頁
              </p>
            </nav>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import axios from "axios";

export default {
  data() {
    return {
      UserId: "",
      RegNo: "",
      CSRF_Token: "",
      vipList: [],
      vipRawData: [],
      currentPage: 1,
      totalPage: "",
      totalNo: "",
      totaltenPageNum: 0,
      tenPageNum: 0,
      showpage: [],
      show: true, // 判斷有無資料
      lang: "tw",
    };
  },

  methods: {
    getPage(page) {
      const vm = this;
      vm.currentPage = page;
      vm.newPageApi();
    },

    nextPage() {
      const vm = this;

      vm.currentPage = Number(vm.currentPage) + 1;
      vm.newPageApi();
    },

    lastPage() {
      const vm = this;
      vm.currentPage = Number(vm.currentPage) - 1;
      vm.newPageApi();
    },

    nexttenPage() {
      const vm = this;
      vm.tenPageNum = vm.tenPageNum + 1;
      vm.showpage = vm.vipRawData[vm.tenPageNum];
      vm.currentPage = vm.showpage[0];
      vm.newPageApi();
    },

    returntenPage() {
      const vm = this;
      vm.tenPageNum = vm.tenPageNum - 1;
      vm.showpage = vm.vipRawData[vm.tenPageNum];
      vm.currentPage = vm.showpage[0];

      vm.newPageApi();
    },

    mainPageApi() {
      const vm = this;

      let url = `/apiExhibitors/ClientVIP/${vm.RegNo}?Page=${vm.currentPage}`;

      axios.get(url).then(function (response) {
        if (response.data.pagetotal > 0) {
          vm.vipList = response.data.Data;
          vm.totalPage = response.data.pagetotal;
          vm.totalNo = response.data.datatotal;

          for (let i = 0; i < vm.totalPage; i++) {
            if (i % 10 === 0) {
              vm.vipRawData.push([]);
            }

            const page = parseInt(i / 10); //parseInt整數公式
            vm.vipRawData[page].push(i + 1);
          }

          //totaltenPageNum 取得共有幾筆十頁
          vm.totaltenPageNum = vm.vipRawData.length;

          //從取得的筆數後，tenNum 計算出現第幾個十頁數

          let anaNowPage = vm.currentPage - 1; //判定第幾頁(十頁)，頁數減一避免進位

          vm.tenPageNum = parseInt(anaNowPage / 10);
          vm.showpage = vm.vipRawData[vm.tenPageNum];

          // console.log(vm.currentPage)

          // vm.getlastpagenum()

          vm.show = true;
        } else {
          vm.show = false;
        }
      });
    },

    newPageApi() {
      const vm = this;

      let url = `/apiExhibitors/ClientVIP/${vm.RegNo}?Page=${vm.currentPage}`;

      axios.get(url).then(function (response) {
        vm.vipList = response.data.Data.ClientVIPs;

        let anaNowPage = vm.currentPage - 1; //判定第幾頁(十頁)，頁數減一避免進位

        vm.tenPageNum = parseInt(anaNowPage / 10);
        vm.showpage = vm.vipRawData[vm.tenPageNum];
      });
    },

    closefancybox() {
      parent.$.fancybox.close();
    },

    DeleteVip(VipNo) {
      const vm = this;

      if (vm.lang == "tw") {
        if (confirm("請確認要刪除此筆VIP名單？")) {
          const info = {
            CSRF: vm.CSRF_Token,
          };

          const url = `/apiExhibitors/ClientVIPDelete/${vm.RegNo}/${VipNo}`;

          axios.post(url, info).then(function (response) {
            // console.log(response.data)

            if (response.data.Code == 200) {
              // alert('您選擇的VIP名單已刪除成功！')
              vm.closefancybox();
              parent.window.location.reload();
            } else if (response.data.Code == 251 || response.data.Code == 500) {
              alert("系統忙碌，請稍後再試！");
              document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/inviteVIPList?no=${vm.RegNo}`;
            } else if (response.data.Code == 252) {
              document.location.href = `https://www.chanchao.com.tw/`;
            } else if (response.data.Code == 253) {
              alert("申請已截止！");
            }
          });
        } else {
          return false;
        }
      } else {
        if (
          confirm(
            "Please re-confirm before you remove the contact from this VIP Registration.",
          )
        ) {
          const info = {
            CSRF: vm.CSRF_Token,
          };

          const url = `/apiExhibitors/ClientVIPDelete/${vm.RegNo}/${VipNo}`;

          axios.post(url, info).then(function (response) {
            // console.log(response.data.Code)

            if (response.data.Code == 200) {
              alert("The contact has been removed from this VIP registration.");
              document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/inviteVIPList?no=${vm.RegNo}`;
            } else if (response.data.Code == 251) {
              alert("System is busy, please try again later.");
              document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/inviteVIPList?no=${vm.RegNo}`;
            } else if (response.data.Code == 252) {
              document.location.href = `https://www.chanchao.com.tw/`;
            } else if (response.data.Code == 253) {
              alert("The application is closed! ");
            } else if (response.data.Code == 500) {
              alert("System is busy, please try again later.");
            }
          });
        } else {
          return false;
        }
      }
    },
  },

  created() {
    const vm = this;

    $(() => {
      $("#SliderTop").click(() => {
        $("html,body").animate({ scrollTop: 0 }, "slow");
        return false;
      });

      $(window)
        .scroll(function () {
          if ($(this).scrollTop() > 300) {
            $("#SliderTop").fadeIn(222);
          } else {
            $("#SliderTop").stop().fadeOut(222);
          }
        })
        .scroll();
    });

    //CSRF_Token
    axios
      .get("https://www.chanchao.com.tw/apiExhibitors/CSRF_Token")
      .then((response) => {
        vm.CSRF_Token = response.data;
      });

    //url取出展碼
    let currentUrl = location.href;
    vm.RegNo = currentUrl.split("no=")[1];

    //   //取天數
    //   let urlParams = new URLSearchParams(window.location.search)
    //   vm.days = urlParams.get('d')

    vm.mainPageApi();
  },
};
</script>

<style lang="scss">
html,
body {
  background-color: rgb(255, 255, 255);
}

.list-group-item {
  padding: 0.4rem 0.8rem;
}

.card-body {
  padding: 0.5rem;
}

.card-header {
  padding: 0.35rem 0.8rem;
  margin-bottom: 0;
  background-color: #e9eef4;
  border-bottom: 0px;
}
</style>
